module.exports = __webpack_public_path__ + "static/media/12.b469d6f9.jpg";